/**
 * The one heading shape every cabinet screen uses.
 *
 * `<h1>` ONCE PER SCREEN, and it is this. The pages below it use `<h2>`/`<h3>` through Mantine's
 * `Title order`, so the outline a screen reader announces matches the outline a sighted reader
 * sees. Nothing in web/ui supplies this yet (`PageHeader` is in the 39-component inventory and is
 * not built), so it lives here for the same collision reason as ./states.tsx.
 */
import { Group, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

export interface CabinetPageHeaderProps {
  title: string;
  /** One sentence saying what this screen answers. Not decoration — it sets expectations. */
  lede?: string;
  actions?: ReactNode;
}

export function CabinetPageHeader({ title, lede, actions }: CabinetPageHeaderProps) {
  return (
    <Group justify="space-between" align="flex-start" wrap="wrap" gap="md">
      <Stack gap={4} style={{ flex: '1 1 320px' }}>
        <Title order={1} style={{ fontSize: 'clamp(26px, 3.4vw, 34px)', letterSpacing: '-0.02em' }}>
          {title}
        </Title>
        {lede === undefined ? null : (
          <Text size="sm" c="dimmed" maw={600} style={{ lineHeight: 1.6 }}>
            {lede}
          </Text>
        )}
      </Stack>
      {actions === undefined ? null : <Group gap="sm">{actions}</Group>}
    </Group>
  );
}
